import React from 'react'
import Button from 'components/theme/Button'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { addSection } from 'actions/customForm/addOrEdit'
import { Add } from '@material-ui/icons'
import { withStyles } from '@material-ui/core'

const styles = (theme) => ({
	button: {
		position: 'absolute',
		right: 0,
		bottom: '-43px',
		[theme.breakpoints.down('sm')]: {
			bottom: 78,
			right: -27,
		},
	},
})

const AddSectionButton = ({
	/* formTypeSelected, */ addSection,
	disabled,
	classes,
}) => (
	<div className={classes.button}>
		<Button
			// className={classes.button}
			onClick={() => addSection()}
			color="secondary"
			disabled={disabled}
		>
			<Add style={{ marginRight: 3, fontSize: 20 }} />
			Add Section
		</Button>
	</div>
)

export default connect(
	(state) => ({
		// formTypeSelected: state.signupForm.addOrEdit.formTypeSelected,
		disabled:
			typeof state.customForm.addOrEdit.sectionBeingEditedID === 'string',
	}),
	(dispatch) => bindActionCreators({ addSection }, dispatch),
)(withStyles(styles)(AddSectionButton))
